export const SMALL_DEVICE_WIDTH = 414;
export const MEDIUM_DEVICE_WIDTH = 768;
export const LARGE_DEVICE_WIDTH = 992;
export const EXTRA_LARGE_DEVICE_WIDTH = 1366;
